function initHamburger() {
	const hamburger = document.querySelector(".hamburger");
	const menuMobile = document.querySelector(".header__nav");
	if (!hamburger) return;

	hamburger.addEventListener("click", function () {
		hamburger.classList.toggle("is-active");

		const isExpanded = this.getAttribute("aria-expanded") === "true" || false;
		this.setAttribute("aria-expanded", !isExpanded);

		menuMobile.classList.toggle("is-open");
		document.body.classList.toggle("no-scroll", menuMobile.classList.contains("is-open"));
	});
}

export { initHamburger };
